export const DESKTOP = 1280;
export const PHONE = 600;
export const TABLET = 720;
